export const HKPage = [
    {
        path: '/account',
        name: 'account',
        meta: {
            title: '复星国际证券开户',
        },
        component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/pages/home.vue'),
    },
    {
        path: '/HK_IDcard',
        name: 'HK_IDCARD',
        meta: {
            title: '复星国际证券开户',
        },
        component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccountHK/hk_IDcard.vue'),
    },
    {
        path: '/UserInfo',
        name: 'USERINFO',
        meta: {
            title: '复星国际证券开户',
        },
        component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccountHK/hk_UserInfo.vue'),
    },
    {
        path: '/ProofAddress',
        name: 'PROOFADDRESS',
        meta: {
            title: '复星国际证券开户',
        },
        component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccountHK/hk_ProofAddress.vue'),
    },
    // {
    //   path: '/addBankCard',
    //   name: 'ADDBANKCARD',
    //   meta: {
    //     title: '复星国际证券开户',
    //   },
    //   component: () =>import(/* webpackChunkName: "openAccountMain" */ '@/views/bankCard/addBankCard.vue'),
    // },{
    //   path: '/addBankCardInFo',
    //   name: 'ADDBANKCARDINFO',
    //   meta: {
    //     title: '复星国际证券开户',
    //     des: '地址证明'
    //   },
    //   component: () =>import(/* webpackChunkName: "openAccountMain" */ '@/views/bankCard/addBankCardInFo.vue'),
    // },
    {
        path: '/transitionGold',
        name: 'TRANSITIONGOLD',
        meta: {
            title: '复星国际证券开户',
            des: '跳转出入金的中间页面',
            submited: true,
        },
        component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccountHK/transitionGold.vue'),
    },
    {
        path: '/AccountStatus',
        name: 'ACCOUNTSTATUS',
        meta: {
            title: '复星国际证券开户',
            des: '开户状态页',
            submited: true,
        },
        component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccountHK/AccountStatus.vue'),
    },
]
